import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { navigationService } from "../NavigationService";
import { MenuRouteItem } from "@/components/menu/types";

export function useGetNavigationList(
    options?: UseQueryOptions<MenuRouteItem[]>
) {
    return useQuery<MenuRouteItem[]>({
        queryKey: ["navigationMenus"],
        queryFn: () => navigationService.getNavigationList(),
        staleTime: 24 * 60 * 60 * 1000, // 24 hours
        ...options,
    });
}

export function useGetNavigationListByUser(
    userId: number,
    options?: UseQueryOptions<MenuRouteItem[]>
) {
    return useQuery<MenuRouteItem[]>({
        queryKey: ["navigationMenus", userId],
        queryFn: () => navigationService.getNavigationListByUser(userId),
        staleTime: 24 * 60 * 60 * 1000, // 24 hours
        ...options,
    });
}
